export class MultiBeadChipUpdate{
  "sourceplateids" : string[];
  "labid":string;
  "step":string;
  "status":string;
  "puid":string;
  "actionRunTime":number;
  "action":string;
  "liquidHandler": string;
  "plateids": string[] = [];
  "completeplateids": boolean[] = [];
}
